import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import CustomLink from './CustomLink';

type RouterLinkProps = {
  children: React.ReactNode;
  className?: string;
  to: string;
};

function RouterLink({ children, className = '', ...rest }: RouterLinkProps) {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
  };

  return (
    <CustomLink
      className={classNames(className, 'tracking-normal')}
      component={Link}
      // @ts-expect-error type inferring from JS causes type mismatch
      onClick={onClick}
      {...rest}
    >
      {children}
    </CustomLink>
  );
}

export default RouterLink;
